import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFeedSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.03723 5.45144L10.5859 14.0001C11.3669 14.7811 12.6332 14.7811 13.4143 14.0001L21.9628 5.45153C22.2992 5.87734 22.5 6.41522 22.5 7V17C22.5 18.3807 21.3807 19.5 20 19.5H4C2.61929 19.5 1.5 18.3807 1.5 17V7C1.5 6.41518 1.70081 5.87727 2.03723 5.45144ZM3.91561 4.5014C3.94363 4.50047 3.97176 4.5 4 4.5H20C20.0283 4.5 20.0565 4.50047 20.0845 4.5014L12.0001 12.5859L3.91561 4.5014Z",
		fill: "#0FAFAF"
	})
});
export default SvgFeedSelected;
